var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStep1Ringsinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 892 800"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 446,
  cy: 400,
  r: 149.625,
  stroke: "#ADA2D2",
  strokeDasharray: "1.5 1.5",
  strokeWidth: 0.75
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 446,
  cy: 400,
  r: 299.625,
  stroke: "#ADA2D2",
  strokeDasharray: "1.5 1.5",
  strokeWidth: 0.75
})));
export default SvgStep1Ringsinline;